module.exports = __webpack_public_path__ + "static/media/support.2308110d.png";